angular.module('content_delivery_system').factory("ContentDeliveryFactory", ["$resource", function ($resource) {
	return $resource('/api/v1.0/articles/delivery/', {}, {
		query: {
			isArray: false
		},
		send: {
			method: 'POST'
		}
	})
}]);